(function(){
  'use strict';
  const PLAN_DATA = window.WCPlanData || [];
  const LABELS = {
    time:{fri:'Freitagabend',sat_day:'Samstag tagsüber',sat_evening:'Samstagabend',sun:'Sonntag',full_day:'ein ganzer Tag'},
    crew:{couple:'Couple',duo:'zu zweit',small:'kleine Crew',large:'große Crew',solo:'solo'},
    place:{home:'zuhause',outdoor:'draußen',city:'in der Stadt',mix:'ein Mix',any:'Ort egal'},
    mood:{relaxed:'entspannt',food:'Food',drinks:'Drinks',active:'aktiv',culture:'Kultur & Entdecken',surprise:'Überraschung'},
    budget:{free:'möglichst kostenlos',b25:'bis 25 €',b50:'bis 50 €',b100:'bis 100 €',flex:'Budget zweitrangig'},
    weather:{sun:'Sonne',mixed:'wechselhaft',rain:'Regen',unknown:'noch unklar',any:'Wetter egal'}
  };
  const BUDGET_CAP={free:0,b25:25,b50:50,b100:100,flex:999};
  const TIME_CAP={fri:330,sat_day:420,sat_evening:360,sun:450,full_day:720};
  const TIME_START={fri:18*60,sat_day:11*60,sat_evening:18*60,sun:11*60,full_day:10*60};
  const QUERY_KEYS={time:'t',crew:'c',place:'p',mood:'m',budget:'b',weather:'w'};
  const REQUIRED=['time','crew','place','mood','budget','weather'];

  function init(root){
    if(!root || root.dataset.wcPlanReady==='true') return;
    root.dataset.wcPlanReady='true';
    const form=root.querySelector('[data-wc-plan-form]');
    const results=root.querySelector('[data-wc-plan-results]');
    const grid=root.querySelector('[data-wc-plan-grid]');
    const status=root.querySelector('[data-wc-plan-status]');
    const summary=root.querySelector('[data-wc-plan-summary]');
    const bar=root.querySelector('[data-wc-plan-progress-bar]');
    const progressLabel=root.querySelector('[data-wc-plan-progress-label]');
    if(!form || !results || !grid) return;

    const values=restoreFromUrl(form);
    updateProgress(form,bar,progressLabel);
    form.addEventListener('change',()=>updateProgress(form,bar,progressLabel));

    form.addEventListener('submit',function(e){
      e.preventDefault();
      const answers=getAnswers(form);
      const missing=REQUIRED.filter(k=>!answers[k]);
      if(missing.length){
        status.textContent='Bitte beantworte alle sechs Fragen.';
        const first=form.querySelector('[name="'+missing[0]+'"]');
        if(first) first.focus();
        return;
      }
      status.textContent='';
      renderResults(root,grid,results,summary,answers);
      writeUrl(answers);
      requestAnimationFrame(()=>results.scrollIntoView({behavior:prefersReduced()?'auto':'smooth',block:'start'}));
    });

    root.addEventListener('click',async function(e){
      const view=e.target.closest('[data-wc-plan-view]');
      if(view){
        const card=view.closest('[data-plan-id]');
        const details=card && card.querySelector('details');
        if(details){ details.open=!details.open; if(details.open) details.scrollIntoView({behavior:prefersReduced()?'auto':'smooth',block:'nearest'}); }
        return;
      }
      const share=e.target.closest('[data-wc-plan-share]');
      if(share){
        const plan=PLAN_DATA.find(p=>p.id===share.dataset.wcPlanShare);
        if(plan) await sharePlan(plan,share);
        return;
      }
      const newPlan=e.target.closest('[data-wc-plan-new]');
      if(newPlan){
        form.reset(); status.textContent=''; results.hidden=true; grid.innerHTML=''; updateProgress(form,bar,progressLabel); clearUrl(); form.scrollIntoView({behavior:prefersReduced()?'auto':'smooth',block:'start'}); return;
      }
      const edit=e.target.closest('[data-wc-plan-edit]');
      if(edit){ form.scrollIntoView({behavior:prefersReduced()?'auto':'smooth',block:'start'}); const first=form.querySelector('input:checked'); if(first) first.focus(); }
    });

    if(values.complete){
      const answers=getAnswers(form);
      renderResults(root,grid,results,summary,answers,false);
    }
  }

  function getAnswers(form){
    const out={}; REQUIRED.forEach(k=>{ const el=form.querySelector('[name="'+k+'"]:checked'); out[k]=el?el.value:''; }); return out;
  }
  function updateProgress(form,bar,label){
    const a=getAnswers(form); const count=REQUIRED.filter(k=>a[k]).length; if(bar) bar.style.width=(count/6*100)+'%'; if(label) label.textContent=count+' / 6 beantwortet';
  }
  function isHardConflict(plan,a){
    if(!plan.times.includes(a.time)) return true;
    if(plan.duration>TIME_CAP[a.time]) return true;
    if(!plan.crews.includes(a.crew)) return true;
    const cap=BUDGET_CAP[a.budget]; if(cap<999 && plan.requiredMin>cap) return true;
    if(a.weather==='rain' && plan.outdoorHeavy && !plan.rainAlternative) return true;
    if(a.place!=='any' && plan.settingStrict && !plan.settings.includes(a.place) && !plan.settings.includes('mix') && !plan.settings.includes('any')) return true;
    return false;
  }
  function scorePlan(plan,a){
    if(isHardConflict(plan,a)) return null;
    let s=0;
    s+=24;
    s+=plan.crews.length<=3?20:17;
    if(a.place==='any') s+=13;
    else if(plan.settings.includes(a.place)) s+=16;
    else if(plan.settings.includes('mix')||plan.settings.includes('any')) s+=12;
    else s+=3;
    if(a.mood==='surprise') s+=plan.vibes.includes('surprise')?20:15;
    else if(plan.vibes.includes(a.mood)) s+=20;
    else if(plan.vibes.includes('surprise')) s+=10;
    else s+=4;
    const cap=BUDGET_CAP[a.budget];
    if(a.budget==='flex') s+=12;
    else if(plan.maxCost<=cap) s+=12;
    else if(plan.requiredMin<=cap) s+=8;
    if(a.weather==='any'||a.weather==='unknown') s+=7;
    else if(plan.weather.includes(a.weather)||plan.weather.includes('any')) s+=8;
    else if(a.weather==='rain'&&plan.rainAlternative) s+=6;
    else s+=2;
    return Math.max(0,Math.min(100,s));
  }
  function chooseResults(a){
    const ranked=PLAN_DATA.map(p=>({plan:p,score:scorePlan(p,a)})).filter(x=>x.score!==null).sort((x,y)=>y.score-x.score||x.plan.id.localeCompare(y.plan.id));
    if(ranked.length<3){
      const used=new Set(ranked.map(x=>x.plan.id));
      PLAN_DATA.forEach(p=>{
        if(ranked.length>=3||used.has(p.id)) return;
        const clone=Object.assign({},p,{settingStrict:false}); const score=scorePlan(clone,a); if(score!==null){ranked.push({plan:p,score:Math.max(0,score-8)}); used.add(p.id);}
      });
      ranked.sort((x,y)=>y.score-x.score||x.plan.id.localeCompare(y.plan.id));
    }
    const best=ranked[0], alt=ranked[1];
    let wildcard=ranked.slice(2).find(x=>{
      const moodContrast=a.mood!=='surprise'&&!x.plan.vibes.includes(a.mood);
      const settingContrast=a.place!=='any'&&!x.plan.settings.includes(a.place);
      const intensityContrast=best&&x.plan.intensity!==best.plan.intensity;
      return (moodContrast||settingContrast||intensityContrast) && x.score>=55;
    }) || ranked[2];
    return [best,alt,wildcard].filter(Boolean);
  }
  function renderResults(root,grid,results,summary,a,announce=true){
    const picks=chooseResults(a); const labels=['BEST MATCH','GOOD ALTERNATIVE','WILDCARD'];
    grid.innerHTML=picks.map((x,i)=>cardHtml(x.plan,x.score,labels[i],a,i===0)).join('');
    if(summary) summary.textContent=LABELS.time[a.time]+' · '+LABELS.crew[a.crew]+' · '+LABELS.mood[a.mood]+' · '+LABELS.budget[a.budget];
    results.hidden=false;
    if(announce){ const live=root.querySelector('[data-wc-plan-live]'); if(live) live.textContent='Drei passende Weekend-Pläne wurden erstellt.'; }
  }
  function cardHtml(p,score,rank,a,top){
    const tags=[LABELS.time[a.time],LABELS.crew[a.crew],p.intensity,p.alcoholFree?'alkoholfrei möglich':'mit Drinks gedacht'];
    const schedule=timelineFor(p,a.time);
    const rain='<p class="wc-plan__rain"><strong>PLAN B</strong><br>'+esc(planB(p,a))+'</p>';
    const checklist=executionChecklist(p,a);
    return '<article class="wc-plan__card'+(top?' wc-plan__card--top':'')+'" data-plan-id="'+esc(p.id)+'">'+
      '<div class="wc-plan__card-top"><div><p class="wc-plan__rank">'+rank+'</p><h3>'+esc(p.name)+'</h3></div><div class="wc-plan__score"><strong>'+score+'%</strong><span>Match</span></div></div>'+
      '<div class="wc-plan__tags">'+tags.map(t=>'<span class="wc-plan__tag">'+esc(t)+'</span>').join('')+'</div>'+
      '<p class="wc-plan__why"><strong>Warum er passt.</strong> '+esc(p.reason)+' '+matchSentence(p,a)+'</p>'+
      '<details class="wc-plan__plan"><summary>DER KONKRETE ABLAUF</summary><div class="wc-plan__timeline">'+schedule.map(s=>'<div class="wc-plan__timeline-row"><strong>'+s.time+'</strong><span>'+esc(s.text)+'</span></div>').join('')+'</div><div class="wc-plan__execution"><strong>VOR DEM START KLÄREN</strong><ul>'+checklist.map(item=>'<li>'+esc(item)+'</li>').join('')+'</ul></div></details>'+
      '<div class="wc-plan__facts"><div class="wc-plan__fact"><strong>Budget</strong><span>'+esc(p.budget)+'</span></div><div class="wc-plan__fact"><strong>Dauer</strong><span>'+durationText(p.duration)+'</span></div><div class="wc-plan__fact"><strong>Vorbereitung</strong><span>'+esc(p.prep)+'</span></div></div>'+
      '<div class="wc-plan__mission"><strong>Weekend Mission</strong><p>'+esc(p.mission)+'</p></div>'+rain+
      '<div class="wc-plan__actions"><button type="button" class="wc-plan__action wc-plan__action--primary" data-wc-plan-view>PLAN ANSEHEN</button><button type="button" class="wc-plan__action" data-wc-plan-share="'+esc(p.id)+'">MIT DER CREW TEILEN</button></div></article>';
  }
  function executionChecklist(p,a){
    const items=[p.prep];
    if(a.crew==='solo') items.push('Startzeit festlegen und den ersten Stopp vorab speichern – der Rest darf spontan bleiben.');
    else items.push('Eine Person bestätigt Startzeit und Treffpunkt; eine zweite behält Budget und nächsten Stopp im Blick.');
    if(a.budget==='free') items.push('Nur kostenlose Stationen wählen und Wasser oder Snacks von zuhause mitnehmen.');
    else if(a.budget!=='flex') items.push('Vorher eine persönliche Obergrenze festlegen und spontane Zusatzstopps nur innerhalb dieses Rahmens wählen.');
    else items.push('Trotz flexiblem Budget einen Fixpunkt reservieren; alles andere bleibt spontan.');
    items.push('Öffnungszeiten, Tickets oder Reservierungen am selben Tag aktuell prüfen, sofern der Plan externe Orte enthält.');
    return items;
  }
  function planB(p,a){
    if(p.rainAlternative) return p.rainAlternative;
    if(p.settings.includes('home')) return 'Der Ablauf bleibt zuhause bestehen. Outdoor-Anteile werden durch eine zusätzliche Tasting-, Musik- oder Spielrunde ersetzt.';
    if(a.weather==='rain'||a.weather==='mixed') return 'Wählt vorab einen Indoor-Spot im selben Viertel. Reihenfolge und Zeitfenster bleiben gleich, lange Wege fallen weg.';
    return 'Speichert einen wetterfesten Ort in der Nähe des Hauptstopps. Falls Wetter oder Verfügbarkeit kippen, wechselt nur die Location – nicht den ganzen Plan.';
  }
  function matchSentence(p,a){
    const bits=[];
    if(p.vibes.includes(a.mood)) bits.push('Die Stimmung trifft „'+LABELS.mood[a.mood]+'“.');
    if(a.budget==='free'&&p.requiredMin===0) bits.push('Er funktioniert ohne verpflichtende Ausgaben.');
    else if(a.budget!=='flex') bits.push('Der Pflichtaufwand bleibt innerhalb deines Budgets.');
    if(a.weather==='rain'&&p.rainAlternative) bits.push('Eine Regenvariante ist bereits mitgedacht.');
    if(a.crew==='solo') bits.push('Der Ablauf funktioniert auch allein.');
    return bits.join(' ');
  }
  function timelineFor(p,timeKey){
    const base=TIME_START[timeKey]||11*60; return p.steps.map(s=>({time:clock(base+s.offset),text:s.text}));
  }
  function clock(mins){ mins=((mins%1440)+1440)%1440; const h=Math.floor(mins/60),m=mins%60; return String(h).padStart(2,'0')+':'+String(m).padStart(2,'0'); }
  function durationText(m){ const h=Math.floor(m/60),min=m%60; if(!min) return h+' Std.'; return h+' Std. '+min+' Min.'; }
  async function sharePlan(p,button){
    const text='Unser Weekend Plan: '+p.share+'. Erstellt mit Weekend Tools von Weekend Culture.';
    const url=cleanShareUrl();
    try{
      if(navigator.share){ await navigator.share({title:'Weekend Culture · The Plan',text:text,url:url}); button.textContent='GETEILT'; setTimeout(()=>button.textContent='MIT DER CREW TEILEN',1500); return; }
      await copyText(text+'\n'+url); button.textContent='KOPIERT'; setTimeout(()=>button.textContent='MIT DER CREW TEILEN',1500);
    }catch(err){ if(err&&err.name==='AbortError') return; try{await copyText(text+'\n'+url);button.textContent='KOPIERT';setTimeout(()=>button.textContent='MIT DER CREW TEILEN',1500);}catch(e){} }
  }
  function cleanShareUrl(){ const u=new URL(window.location.href); u.hash=''; return u.toString(); }
  async function copyText(text){ if(navigator.clipboard&&window.isSecureContext){return navigator.clipboard.writeText(text);} const ta=document.createElement('textarea'); ta.value=text; ta.setAttribute('readonly',''); ta.style.position='fixed';ta.style.opacity='0';document.body.appendChild(ta);ta.select();document.execCommand('copy');ta.remove(); }
  function writeUrl(a){ try{const u=new URL(window.location.href); REQUIRED.forEach(k=>u.searchParams.set(QUERY_KEYS[k],a[k])); history.replaceState({},'',u);}catch(e){} }
  function clearUrl(){ try{const u=new URL(window.location.href); Object.values(QUERY_KEYS).forEach(k=>u.searchParams.delete(k)); history.replaceState({},'',u.pathname+u.search+u.hash);}catch(e){} }
  function restoreFromUrl(form){
    let count=0; try{const u=new URL(window.location.href); REQUIRED.forEach(k=>{const v=u.searchParams.get(QUERY_KEYS[k]); if(!v)return; const input=form.querySelector('[name="'+k+'"][value="'+cssEscape(v)+'"]'); if(input){input.checked=true;count++;}});}catch(e){} return {complete:count===6};
  }
  function cssEscape(v){ return String(v).replace(/["\\]/g,'\\$&'); }
  function esc(v){ return String(v==null?'':v).replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c])); }
  function prefersReduced(){return window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;}
  function boot(scope){(scope||document).querySelectorAll('[data-wc-plan-root]').forEach(init);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>boot(document)); else boot(document);
  document.addEventListener('shopify:section:load',e=>boot(e.target));
  window.WCPlanTool={data:PLAN_DATA,score:scorePlan,choose:chooseResults,hardConflict:isHardConflict};
})();
